/**
 * @generated SignedSource<<421797cae989318d396b4dc04a5f5137>>
 * @relayHash f2740258825458d26ebde76724d08ae3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cf56a421f6bdf8663e4ceb8127bb7d5d5f0dd3ac585d0e6f9b29b0e5470de35f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { newUgsJiraBoardFetchPullRequestDetailsForIssueNewQuery } from './newUgsJiraBoardFetchPullRequestDetailsForIssueNewQuery.graphql';

const node: PreloadableConcreteRequest<newUgsJiraBoardFetchPullRequestDetailsForIssueNewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cf56a421f6bdf8663e4ceb8127bb7d5d5f0dd3ac585d0e6f9b29b0e5470de35f",
    "metadata": {},
    "name": "newUgsJiraBoardFetchPullRequestDetailsForIssueNewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
